import { render, staticRenderFns } from "./physiotherapyMedicine.vue?vue&type=template&id=23369b93&"
import script from "./physiotherapyMedicine.vue?vue&type=script&lang=js&"
export * from "./physiotherapyMedicine.vue?vue&type=script&lang=js&"
import style0 from "./physiotherapyMedicine.vue?vue&type=style&index=0&id=23369b93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports